<template>
  <el-dialog
    :visible.sync="airUnitDialogVisible"
    width="626px"
    top="4vh"
    :before-close="closeExhaustFanDialog"
  >
    <timing-task :innerVisible.sync="innerVisible" :historyTable="historyTable" />
    <template slot="title"> <title-icon />空调机组 </template>
    <div style="width: 100%; height: 260px">
      <div style="float: left; padding: 20px; width: 40%">
        <img src="../../../../../../../assets/images/air-unit.png" />
        <p>
          <span style="margin-left: 20px; margin-right: 10px">运行状态:</span>
          <template v-if="monitorType001001 == 'true'">
            <span class="statusClass autoHand"> 运行 </span>
          </template>
          <template v-else>
            <span class="statusClass stop"> 停止 </span>
          </template>
        </p>
      </div>
      <div style="float: left; width: 50%; height: 260px">
        <div class="collectingWell-c-r speedWind-c-r fl">
          <div>
            <span class="titleClass">故障状态</span>
            <template v-if="monitorType010004 == 'true'">
              <span class="statusClass fault"> 故障 </span>
            </template>
            <template v-else>
              <span class="statusClass autoHand"> 正常 </span>
            </template>
          </div>
          <div>
            <span class="titleClass">远程/就地</span>
            <template v-if="monitorType014050 == 'true'">
              <span class="statusClass autoHand"> 远程 </span>
            </template>
            <template v-else>
              <span class="statusClass active"> 就地 </span>
            </template>
          </div>
          <div>
            <span class="titleClass">启动控制</span>
            <el-switch
              :disabled="monitorType014050 !== 'true'"
              v-model="control"
              @change="controlPoint('001002', $event)"
            >
            </el-switch>
            <el-button
              v-if="historyTable.length > 0"
              type="primary"
              plain
              icon="el-icon-timer"
              size="mini"
              class="btn"
              @click="innerVisible = true"
            ></el-button>
          </div>
          <!-- <div>
            <span class="titleClass">送风温度</span>
            <el-input-number
              v-model="temperature"
              :controls="false"
              @change="controlPoint('110008', $event)"
              :min="0"
              :max="100"
            ></el-input-number>
          </div> -->
        </div>
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="closeExhaustFanDialog">{{
        $t("commons.close")
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  setPoint
} from '@/api/business/base/tenant/map'
import TimingTask from './timingTask'

export default {
  components: {
    TimingTask
  },
  props: {
    // //是否显示
    airUnitDialogVisible: {
      type: Boolean
    },
    // 设备信息
    deviceInfo: {
      type: Object,
    },
    // 设备类型编码
    deviceType: {
      type: String,
    },
  },
  computed: {
    telecommandMessage() {
      return this.$store.getters.telecommandMessage;
    },
    telemeteringMessage() {
      return this.$store.getters.telemeteringMessage;
    },
    isShow() {
      return this.airUnitDialogVisible;
    }
  },
  watch: {
    //侦听遥信数据
    telecommandMessage(message) {
      this.telecommandMessageInfo(message);
    },
    //侦听遥测数据
    telemeteringMessage(message) {
      this.telemeteringMessageInfo(message);
    },
    isShow: function () {
      this.isShowDialog();
    }
  },
  data() {
    return {
      // dialogVisible:false,
      currentDeviceType: '001010',
      monitorType001001: null,
      monitorType014050: null,
      monitorType001002: null,
      monitorType010004: null,
      monitorType110008: null,
      control: false,
      temperature: 23,
      advancedSettingScreenDialog: false,
      timer: null,
      innerVisible: false,
      historyTable: []
    }
  },
  methods: {
    isShowDialog() {
      if (this.airUnitDialogVisible) {
        this.initMonitorRedisData();
        
      }
    },
    initMonitorRedisData() {
      this.historyTable = []
      this.deviceInfo.monitorList.map(v => {
        this.findMonitorTypeValue(v.monitorType);
      })
    },
    findMonitorTypeValue(monitorType) {
      let monitorObj = this.deviceInfo.monitorList.find((item) => {
        return item.monitorType == monitorType;
      })
     
      if (parseInt(monitorType) === 10000) {
        this.historyTable.push(monitorObj.historyTable)
      }
      this["monitorType" + monitorType] = monitorObj.value;
      this.control = this.monitorType001001 === 'true' ? true : false
      this.temperature = +this.monitorType110008

    },
    findSourceCodeValue(message) {
      if (this.deviceInfo != null) {
        let monitorObj = this.deviceInfo.monitorList.find((item) => {
          return item.historyTable == message.sourceCode;
        })
        if (monitorObj != undefined) {
          this["monitorType" + monitorObj.monitorType] = message.value;
          this.control = this.monitorType001001 === 'true' ? true : false
          this.temperature = +this.monitorType110008
        }
      }
    },
    closeExhaustFanDialog() {
      this.$emit('update:deviceType', null)
      this.$emit('update:airUnitDialogVisible', false)
    },
    //遥信
    telecommandMessageInfo(message) {
      this.findSourceCodeValue(message);
    },
    //遥测
    telemeteringMessageInfo(message) {
      this.findSourceCodeValue(message);
    },
    controlPoint(monitorType, value) {
      //  this.$emit('change', true)
      if (this.deviceInfo != null) {
        let monitorObj = this.deviceInfo.monitorList.find((item) => {
          return item.monitorType == monitorType;
        })
        setPoint({ "sourceCode": monitorObj.historyTable, "value": value })
      }
    }
  }
}
</script>

<style scoped>
.titleClass {
  display: inline-block;
  height: 28px;
  line-height: 28px;
  min-width: 103px;
  text-align: right;
  margin-right: 10px;
}
.statusClass {
  display: inline-block;
  width: 75px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  color: #fff;
  background-color: #20ebb6;
  margin-right: 10px;
}
.collectingWell-c-r {
  margin-top: 20px;
}
.collectingWell-c-r > div {
  height: 28px;
  margin-bottom: 20px;
}
.active {
  background-color: #bcd0d5;
}
.autoHand {
  background-color: rgb(143, 170, 220);
}
.fault {
  background-color: #f43d3d;
}
.point {
  cursor: pointer;
}
.stop {
  background-color: rgb(217, 217, 217);
}
.el-input-number--medium {
  width: 100px;
}
.btn {
  margin-left: 10px;
}
</style>
